export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">关于UU漫画</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">因为热爱，所以专注</p>

        <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            <strong className="text-primary-500">UU漫画</strong>诞生于一群漫画爱好者的共同热爱。
            我们深知漫荒的痛苦——追完一部好作品后，不知道下一本该看什么的空虚感。
            正因如此，我们打造了这个专注于<strong>韩漫推荐、日漫大全、国漫排行榜</strong>的一站式平台。
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            UU漫画不止是一个目录，更是一个有温度的漫画社区入口。我们每日追踪热门漫画类型的最新动态，
            通过编辑精选、读者热评和实时榜单，帮你从海量作品中快速找到好看的漫画。
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            从热血少年到甜蜜恋爱，从悬疑推理到奇幻冒险——无论你的口味如何，
            <strong className="text-primary-500">免费漫画大全</strong> UU漫画都希望成为你探索漫画世界的起点。
          </p>
        </div>
      </div>
    </section>
  );
}